import { Menu as AntMenu, type MenuProps as AntMenuProps } from 'antd';
import type { FC } from 'react';

type Props = {
  selectedKeys?: AntMenuProps['selectedKeys'];
  style: AntMenuProps['style'];
  mode: AntMenuProps['mode'];
  theme?: AntMenuProps['theme'];
  items: AntMenuProps['items'];
  onSelect?: AntMenuProps['onSelect'];
};

export type MenuItem = NonNullable<Props['items']>[number];

export const Menu: FC<Props> = (props) => {
  return (
    <AntMenu
      selectedKeys={props.selectedKeys}
      style={props.style}
      mode={props.mode}
      theme={props.theme}
      onSelect={props.onSelect}
      items={props.items}
      inlineIndent={12}
      data-dd-privacy="allow"
    />
  );
};
